"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const store_1 = require("../../utils/store");
const styled_components_1 = __importStar(require("styled-components"));
function Offer({ product }) {
    const theme = (0, styled_components_1.useTheme)();
    const { isWindows } = (0, device_1.usePlatform)();
    if (!(product === null || product === void 0 ? void 0 : product.offer) && !isWindows) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(OfferContainer, { "data-e2e": 'Offer_OfferContainer', children: [(0, jsx_runtime_1.jsx)(OfferPrice, { "data-e2e": 'Offer_OfferPrice', children: product.price.formattedValue }), (0, jsx_runtime_1.jsx)(OfferRibbon, { color: theme.textInverted, height: 20, "data-e2e": 'Offer_OfferRibbon', children: isWindows
                    ? (0, i18n_1.Localized)(i18n_1.Strings.store.offers.webStore.name)
                    : (0, i18n_1.Localized)(store_1.OfferStrings[product.offer.type].name) })] }));
}
exports.Offer = Offer;
const OfferContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  margin: auto auto 0 auto;
`;
const OfferPrice = styled_components_1.default.div `
  margin: 10px auto;

  color: ${props => props.theme.text};

  font-size: 16px;
  text-decoration: line-through;
`;
const OfferRibbon = (0, styled_components_1.default)(ui_1.Pennon) `
  margin: 0 auto;

  color: ${props => props.theme.text};

  font-size: 11px;
`;
